import { createElement } from "react"
import { AppRouteConfig } from "@/types/navigation"
import Login from "@/pages/auth/login"
import Register from "@/pages/auth/register"
import Confirm from "@/pages/auth/confirm"
import ForgotPassword from "@/pages/auth/forgot-password"
import ResetPasswordOtp from "@/pages/auth/reset-password-otp"
import ResetPasswordNew from "@/pages/auth/reset-password-new"
import GoogleCallback from "@/pages/auth/google-callback"
import GitHubCallback from "@/pages/auth/github-callback"
import { ROUTES } from "@/routes/path"

export const authRoutes: AppRouteConfig[] = [
  {
    path: ROUTES.AUTH.LOGIN,
    element: createElement(Login),
    restricted: false,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.AUTH.REGISTER,
    element: createElement(Register),
    restricted: false,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.AUTH.CONFIRM,
    element: createElement(Confirm),
    restricted: false,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.AUTH.FORGOT_PASSWORD,
    element: createElement(ForgotPassword),
    restricted: false,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.AUTH.RESET_PASSWORD_OTP,
    element: createElement(ResetPasswordOtp),
    restricted: false,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.AUTH.RESET_PASSWORD_NEW,
    element: createElement(ResetPasswordNew),
    restricted: false,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.AUTH.GOOGLE_CALLBACK,
    element: createElement(GoogleCallback),
    restricted: false,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.AUTH.GITHUB_CALLBACK,
    element: createElement(GitHubCallback),
    restricted: false,
    showNav: false,
    showSideBar: false,
  },
]
